import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import swal from 'sweetalert';

import {REST_API_END_POINT, dataEncryptKey } from "../../constants/defaultValues";
import axios from 'axios';
import SimpleCrypto from "simple-crypto-js";

var dataCrypto = new SimpleCrypto(dataEncryptKey);

export default class DeleteOrderModal extends Component{
	constructor(props) {
		super(props);
		this.handleDelete = this.handleDelete.bind(this);
    }
		
	handleDelete() {
		document.getElementById("delete-order").disabled=true;
		
		var user_id = localStorage.getItem('user_id');
		var facility_id = localStorage.getItem('facility_id');
		facility_id = dataCrypto.decrypt(facility_id);
		
		var formData = new FormData();
		formData.append('facility_id',facility_id);
		formData.append('user_id',user_id);
		formData.append('order_id',this.props.order_id);

		axios.post(REST_API_END_POINT+'point-of-sale/delete-order',formData).then((res)=>{
			var data = res.data;
			
			document.getElementById("delete-order").disabled=false;
			this.props.dataListRender();
			this.props.toggleModal();
			
			if(data.status==1){
				swal("Success",data.msg,"success");
			}else{
				swal("Failed",data.msg,"warning");
			}
				
		}).catch(e =>{
			console.log("Addition failed , Error ", e);
			document.getElementById("delete-order").disabled=false;
		});
	}
	
    render() {
		return (
			<Modal
			  isOpen={this.props.modalOpen}
			  toggle={this.props.toggleModal}
			  size="md"
			>
				<ModalHeader toggle={this.props.toggleModal}>
					Delete Order
				</ModalHeader>
				
				<ModalBody>
					<p>Are you sure you want to delete this order? This action cannot be undone.</p>
				</ModalBody>
				
				<ModalFooter>
					<Button color="danger" id="delete-order" onClick={this.handleDelete}>
						Delete Order
					</Button>
					<Button color="secondary" outline onClick={this.props.toggleModal}>
						Cancel
					</Button>
				</ModalFooter>
			</Modal>
		);
  }
};
